var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "div",
                { attrs: { id: "searchBox" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "company" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入公司名称" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "company", $$v)
                          },
                          expression: "searchForm.company",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text", id: "closeSearchBtn" },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.word) + " "),
                      _c("i", {
                        class: _vm.showAll
                          ? "el-icon-arrow-up "
                          : "el-icon-arrow-down",
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSearchBtn()
                        },
                      },
                    },
                    [_vm._v("搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetBtn },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-table search-table" },
        [
          _c(
            "el-button",
            {
              staticClass: "el-icon-plus custom-btn",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新增客户")]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogVisible,
                title: "指定联系人",
                width: "30%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { ref: "dialogFormRef", attrs: { model: _vm.dialogForm } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "",
                        prop: "assign",
                        rules: [
                          {
                            required: true,
                            trigger: "change",
                            message: "请指定联系人！",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          model: {
                            value: _vm.dialogForm.assign,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogForm, "assign", $$v)
                            },
                            expression: "dialogForm.assign",
                          },
                        },
                        _vm._l(_vm.assignData, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.yid,
                              attrs: { label: item.rname, value: item.yid },
                            },
                            [_vm._v(_vm._s(item.rname))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.handleDialogCancel } }, [
                    _vm._v("取 消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.submitLoading },
                      on: { click: _vm.handleDialogSubmit },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "customer-table",
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
              },
            },
            [
              _c("el-table-column", { attrs: { label: "序号", prop: "id" } }),
              _c("el-table-column", {
                attrs: { label: "客户类别", prop: "classname" },
              }),
              _c("el-table-column", {
                attrs: { label: "公司名称", prop: "company" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "el-link el-link--primary is-underline",
                            attrs: {
                              to: {
                                name: "generateContract",
                                params: { id: scope.row.id },
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.company) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "联系人", prop: "name" },
              }),
              _c("el-table-column", {
                attrs: { label: "手机/电话", prop: "phone" },
              }),
              _c("el-table-column", {
                attrs: { label: "负责人", prop: "rname" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "customer-director" },
                          [
                            _vm._v(" " + _vm._s(scope.row.rname) + " "),
                            _c(
                              "el-button",
                              {
                                staticClass: "el-icon-thumb",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAssign(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v(" 指定 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-edit-outline",
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 编辑 ")]
                        ),
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              iconColor: "red",
                              title: "确认删除此条数据吗？",
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.handleDelete(scope.row, scope.$index)
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "el-icon-delete",
                                attrs: {
                                  slot: "reference",
                                  type: "danger",
                                  size: "small",
                                },
                                slot: "reference",
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
            attrs: {
              "current-page": _vm.selectPage.pageNum,
              "page-sizes": [20, 50, 100, 200],
              "page-size": _vm.selectPage.pageSize,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.allNum,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("Edit", {
        attrs: {
          dialog: _vm.dialog,
          "form-data": _vm.editFormData,
          type: _vm.type,
        },
        on: { submit: _vm.handleSubmit, close: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }